import { graphql } from '__generated__';

import { useQueryStable } from '@/hooks/useQueryStable';

// https://github.com/dbt-labs/codex-api/blob/main/schema.graphql
// https://github.com/dbt-labs/codex-api/blob/main/frontend/package.json#L33
// https://github.com/dbt-labs/codex-api/blob/main/frontend/codegen.yml
// generates: https://github.com/dbt-labs/codex-api/blob/main/frontend/src/typings/codex.ts
export const GetMostExecutedModels = graphql(/* GraphQL */ `
  query MostExecutedModels($environmentId: BigInt!, $start: Date!, $end: Date!) {
    performance(environmentId: $environmentId) {
      mostExecutedModels(start: $start, end: $end) {
        totalExecutions
        uniqueId
        isDeleted
        byJob {
          jobId
          totalExecutions
        }
      }
    }
  }
`);

type MostExecutedModelsParams = {
  environmentId?: number;
  startDate: string;
  endDate: string;
  limit: number;
  pause?: boolean;
};

export const useMostExecutedModels = ({
  environmentId = 0,
  startDate,
  endDate,
  limit = 5,
  pause,
}: MostExecutedModelsParams) => {
  const query = useQueryStable({
    query: GetMostExecutedModels,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      limit,
    },
    pause: pause || !environmentId || !startDate || !endDate || !limit,
  });

  // TODO: we need a cache invalidation strategy for performance endpoints

  return query;
};
